import React, { Component } from "react";
import PropTypes from "prop-types";
import Banner from "../../../img/banner.jpg";
import TButton from "../../common/TButton";
import * as Theme from "../../../app/Theme";
import * as HLConst from "../NonVisual/HLConst";

class HLHomePageForm extends Component {
    static propTypes = {
        onPageChange: PropTypes.func,
        sideBarOpen: PropTypes.bool,
        onSideBarArrowClick: PropTypes.func,
        wideModeBool: PropTypes.bool,
    };

    static defaultProps = {
        onPageChange: () => console.log("onPageChange"),
        sideBarOpen: false,
        onSideBarArrowClick: () => console.log("onSideBarArrowClick"),
        wideModeBool: true,
    };

    state = {};

    onWelcomeFormNextBtnClick = () => {
        this.props.onSideBarArrowClick(true, () => {
            this.props.onPageChange(HLConst.step3Form);
        });
    };

    onBeginBtnClick = () => {
        this.props.onPageChange(HLConst.introForm);
    };

    render() {
        // const sideBarOpen = props.sideBarOpen;
        // const wideModeBool = props.wideModeBool;

        // const modDivMargin = 15;

        // const modDivWidth = 340;
        // const modDivHeight = 380;

        let welcomeTextStyle = {};
        let welcomeTextStyle2 = {};
        let sourceTextStyle = {};
        // let toolDescriptionStyle = {};
        // let creditStyle = {};
        let beginBtnStyle = {};

        // if (wideModeBool) {

        /* whiteSpace : "nowrap" prevents Welcome text from running into tool description when
               the side bar is open and you shrink the screen. */
        welcomeTextStyle = {
            ...Theme.appTitleFontStyle,
            color: Theme.whiteColor,
            fontWeight: "bold",
            lineHeight: 1.5,
            marginLeft: 115, //210,
            marginTop: 120,
            marginBottom: 90,
            position: "absolute",
            textAlign: "left",
            //textShadow : "2px 2px 20px" + Theme.whiteColor,
            userSelect: "none", // don't let user highlight text
            whiteSpace: "nowrap", // prevents Welcome text from running into tool description
        };

        welcomeTextStyle2 = {
            ...Theme.appTitleFontStyle,
            color: Theme.whiteColor,
            fontWeight: "bold",
            fontSize: 26,
            lineHeight: 1.5,
            marginLeft: 115, //210,
            marginTop: 160,
            marginBottom: 90,
            position: "absolute",
            textAlign: "left",
            //textShadow : "2px 2px 20px" + Theme.whiteColor,
            userSelect: "none", // don't let user highlight text
            width: 705,
        };

        sourceTextStyle = {
            ...Theme.appTitleFontStyle,
            color: Theme.whiteColor,
            // fontWeight   : "bold",
            fontSize: 22,
            lineHeight: 1.5,
            marginLeft: 115, //210,
            marginTop: 605,
            marginBottom: 90, //90
            position: "absolute",
            textAlign: "left",
            //textShadow : "2px 2px 20px" + Theme.whiteColor,
            userSelect: "none", // don't let user highlight text
            width: 705,
        };

        // toolDescriptionStyle = {
        //     color      : Theme.HL_PrimaryColor,
        //     fontFamily : Theme.fontFamily,
        //     lineHeight : 1.5,
        //     marginLeft : 210,
        //     marginTop  : 150,
        //     position   : "absolute",
        //     textAlign  : "left",
        //     textShadow : "2px 2px 20px" + Theme.whiteColor,
        //     userSelect : "none", // don't let user highlight text
        // };

        beginBtnStyle = {
            marginLeft: 700, //950,
            marginTop: 475,
            position: "absolute",
        };

        // }
        // else {
        //
        //     welcomeTextStyle = {
        //         ...Theme.appTitleFontStyle,
        //         color         : Theme.HL_PrimaryColor,
        //         marginLeft    : 40,
        //         marginTop     : 40,
        //         textAlign     : 'left',
        //         userSelect    : 'none',// don't let user highlight text
        //     };
        //
        //     // toolDescriptionStyle = {
        //     //     color         : Theme.HL_PrimaryColor,
        //     //     lineHeight    : 1.5,
        //     //     marginLeft    : 40,
        //     //     marginTop     : 20,
        //     //     textAlign     : 'left',
        //     //     userSelect    : 'none',// don't let user highlight text
        //     //     paddingBottom : '10px',
        //     // };
        //
        //     beginBtnStyle = {
        //         marginLeft : 40,
        //     };
        //
        // }

        // const modDivStyle = {
        //     backgroundColor: Theme.whiteColor,
        //     borderColor: Theme.HL_PrimaryColor,
        //     borderRadius: 20,
        //     borderStyle: "solid",
        //     borderWidth: 2,
        //     height: modDivHeight,
        //     width: modDivWidth,
        // };

        // const modDivUpperBoxStyle = {
        //     height: 280,
        //     width: modDivWidth - modDivMargin * 2,
        // };

        // const modDivEnterBtnBoxStyle = {
        //     height: modDivHeight - modDivUpperBoxStyle.height - 40,
        //     width: modDivWidth - modDivMargin * 2,
        // };

        /* Unfortunately, we can't just grab the height of the button from the button and do 1/2 height of
           the button's container - 1/2 height of the button. */
        // const modDivEnterBtnTop = 10;

        let bannerImg = null;
        let welcomeTextDiv = null;
        let sourceTextDiv = null;

        // if (wideModeBool) {

        bannerImg = (
            <div
                style={{
                    position: "fixed",
                    top: "-40%",
                    left: "-50%",
                    width: "200%",
                    height: "200%",
                    zIndex: -2,
                }}
            >
                <img
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        margin: "auto",
                        minWidth: "50%",
                        minHeight: "50%",
                    }}
                    src={Banner}
                    alt=""
                />
                ;
            </div>
        );

        welcomeTextDiv = (
            <div
                key={"welcomeTextDiv"}
                style={{
                    background: "transparent",
                    backgroundColor: Theme.greenBoxColor,
                    opacity: 0.68,
                    position: "absolute",
                    height: 485,
                    width: 750,
                    //borderColor     : Theme.HL_PrimaryColor,
                    borderRadius: 25,
                    borderStyle: "none",
                    borderWidth: 2,
                    marginLeft: 90, //200,
                    marginTop: 90,
                }}
            ></div>
        );

        sourceTextDiv = (
            <div
                key={"sourceTextDiv"}
                style={{
                    background: "transparent",
                    backgroundColor: Theme.greenBoxColor,
                    opacity: 0.68,
                    position: "absolute",
                    height: 130, //100,
                    width: 750,
                    //borderColor     : Theme.HL_PrimaryColor,
                    borderRadius: 25,
                    borderStyle: "none",
                    borderWidth: 2,
                    marginLeft: 90, //200,
                    marginTop: 590,
                }}
            ></div>
        );

        // }

        const welcomeText = (
            <div>
                <h1 style={welcomeTextStyle}>H-LiST Approach:</h1>
                <br></br>
                <p style={welcomeTextStyle2}>
                    <div>
                        Provides evidence-based recommendations on which maternal and child health, nutrition and water,
                        sanitation and hygiene (WASH) interventions, at specified coverage levels, can save the most
                        lives.
                    </div>
                    <br></br>
                    <div>
                        This approach also includes guidance on developing and costing context-specific activities to
                        achieve intervention coverage levels.
                    </div>
                </p>
            </div>
        );

        const beginBtn = (
            <TButton
                caption={"Begin"}
                captionStyles={{
                    fontSize: 16,
                    ...Theme.labelFontStyle,
                    marginBottom: 5,
                    marginTop: 5,
                }}
                containerStyle={{
                    ...beginBtnStyle,
                }}
                onClick={this.onBeginBtnClick}
            />
        );

        // }

        const sourceText = (
            <div>
                <p style={sourceTextStyle}>
                    <div>
                        H-LiST was developed by the Center for Humanitarian Health at Johns Hopkins University, in
                        collaboration with the Lives Saved Tool (LiST) team and UNHCR. It is supported by the Bill &
                        Melinda Gates Foundation.
                    </div>
                </p>
            </div>
        );

        // const toolDescriptionText =
        //     <h3 style = {toolDescriptionStyle}>
        //         Powered by LiST, a tool for modeling the effect of scaling up proven public health interventions with established effectiveness.
        //     </h3>;

        // let divHeight = "100%";

        // let creditText = null;

        // if (wideModeBool) {
        //     creditText = (
        //         <h6
        //             style={{
        //                 color: Theme.blackColor,
        //                 float: "right",
        //                 margin: 0,
        //                 position: "absolute",
        //                 bottom: 0,
        //                 right: 0,
        //             }}
        //         >
        //             ID 93017741 © chehade foz | Dreamstime.com
        //         </h6>
        //     );
        // } else {
        //     divHeight = Theme.HL_FooterPosition;
        // }

        // const instructionsText =
        //     <h3
        //         style = {{
        //             color     : Theme.whiteColor,
        //             marginTop : 40,
        //         }}
        //     >
        //         [Instructions for proceeding]
        //     </h3>;

        // // const precisionIconBox =
        // //     <TBox
        // //         content         = {[
        // //             <img
        // //                 src = {PrecisionIcon}
        // //             />
        // //         ]}
        // //         justifyContent  = {"flex-end"}
        // //         style           = {{
        // //             width   : modDivWidth - 20,
        // //         }}
        // //     />;
        //
        // const precisionLab =
        //     <h2
        //         style = {{
        //             color     : Theme.HL_SecondaryColor,
        //         }}
        //     >
        //         [Title of area]
        //     </h2>;
        //
        // const precisionDescriptionLab =
        //     <h3
        //         style = {{
        //             fontWeight : "normal",
        //             marginTop  : 0,
        //         }}
        //     >
        //         [Description of area]
        //     </h3>;
        //
        // let precisionUpperBoxContent = [];
        // //precisionUpperBoxContent.push(precisionIconBox);
        // precisionUpperBoxContent.push(precisionLab);
        // precisionUpperBoxContent.push(precisionDescriptionLab);
        //
        // const precisionUpperBox =
        //     <TBox
        //         alignItems     = {"flex-start"}
        //         content        = {precisionUpperBoxContent}
        //         flexDirection  = {"column"}
        //         justifyContent = {"flex-start"}
        //         style          = {{
        //             ...modDivUpperBoxStyle,
        //         }}
        //     />;
        //
        // const precisionNextBtn =
        //     <TButton
        //         caption        = {HLConst.nextBtnText}
        //         onClick        = {() => this.onWelcomeFormNextBtnClick}
        //         color          = {Theme.HL_SecondaryColor}
        //         containerStyle = {{
        //             ...modDivEnterBtnBoxStyle,
        //         }}
        //         style = {{
        //             backgroundColor : Theme.HL_SecondaryColor,
        //             color           : Theme.whiteColor,
        //             top             : modDivEnterBtnTop,
        //             width           : Theme.navBtnWidth,
        //         }}
        //     />;
        //
        // let precisionNextBtnBoxContent = [];
        // precisionNextBtnBoxContent.push(precisionNextBtn);
        //
        // const precisionNextBtnBox =
        //     <TBox
        //         content = {precisionNextBtnBoxContent}
        //     />;
        //
        // let precisionBoxContent = [];
        // precisionBoxContent.push(precisionUpperBox);
        // precisionBoxContent.push(precisionNextBtnBox);
        //
        // const precisionBox =
        //     <TBox
        //         content        = {precisionBoxContent}
        //         flexDirection  = {"column"}
        //         style          = {{
        //             ...modDivStyle,
        //             margin : 10, // needed to prevent boxes from clashing when window is resized and to keep them aligned relative to each other
        //         }}
        //     />;
        //
        // let q1BoxContent = [];
        // q1BoxContent.push(precisionBox);
        //
        // const q1Box =
        //     <TBox
        //         content = {q1BoxContent}
        //     />;

        return (
            <div
                style={{
                    minHeight: window.innerHeight - Theme.HL_FooterOffset, //Theme.HL_FooterPosition,
                }}
            >
                {bannerImg}
                {welcomeTextDiv}
                {welcomeText}
                {beginBtn}
                {sourceTextDiv}
                {sourceText}
                {/*{toolDescriptionText}*/}
                {/*{instructionsText}*/}
                {/*{creditText}*/}
            </div>
        );
    }
}

export default HLHomePageForm;
